module.exports = __webpack_public_path__ + "static/media/minus.49b8e70b.svg";